// Civil Litigation Images
import civilimg1 from "../../assets/Services/civil-litigation/civil-1.jpg";
import civilimg2 from "../../assets/Services/civil-litigation/civil-2.jpg";
import civilimg3 from "../../assets/Services/civil-litigation/civil-3.jpg";
import civilimg4 from "../../assets/Services/civil-litigation/civil-4.jpg";
import civilimg5 from "../../assets/Services/civil-litigation/civil-5.jpg";
import civilimg6 from "../../assets/Services/civil-litigation/civil-6.jpg";
import civilimg7 from "../../assets/Services/civil-litigation/civil-7.jpg";
import civilimg8 from "../../assets/Services/civil-litigation/civil-8.jpg";

// Criminal Litigation Images
import criminalimg1 from "../../assets/Services/criminal-litigation/criminal-1.jpg";
import criminalimg2 from "../../assets/Services/criminal-litigation/criminal-2.jpg";
import criminalimg3 from "../../assets/Services/criminal-litigation/criminal-3.jpg";
import criminalimg4 from "../../assets/Services/criminal-litigation/criminal-4.jpg";
import criminalimg5 from "../../assets/Services/criminal-litigation/criminal-5.jpg";
import criminalimg6 from "../../assets/Services/criminal-litigation/criminal-6.jpg";
import criminalimg7 from "../../assets/Services/criminal-litigation/criminal-7.jpg";
import criminalimg8 from "../../assets/Services/criminal-litigation/criminal-8.jpg";

// Matrimonial Matters Images
import matrimonialimg1 from "../../assets/Services/matrimonial-matters/matrimonial-1.jpg";
import matrimonialimg2 from "../../assets/Services/matrimonial-matters/matrimonial-2.jpg";
import matrimonialimg3 from "../../assets/Services/matrimonial-matters/matrimonial-3.jpg";
import matrimonialimg4 from "../../assets/Services/matrimonial-matters/matrimonial-4.jpg";
import matrimonialimg5 from "../../assets/Services/matrimonial-matters/matrimonial-5.jpg";
import matrimonialimg6 from "../../assets/Services/matrimonial-matters/matrimonial-6.jpg";
import matrimonialimg7 from "../../assets/Services/matrimonial-matters/matrimonial-7.jpg";
import matrimonialimg8 from "../../assets/Services/matrimonial-matters/matrimonial-8.jpg";

// Commercial Matters Images
import commercialimg1 from "../../assets/Services/commercial-law/commercial-1.jpg";
import commercialimg2 from "../../assets/Services/commercial-law/commercial-2.jpg";
import commercialimg3 from "../../assets/Services/commercial-law/commercial-3.jpg";
import commercialimg4 from "../../assets/Services/commercial-law/commercial-4.jpg";
import commercialimg5 from "../../assets/Services/commercial-law/commercial-5.jpg";
import commercialimg6 from "../../assets/Services/commercial-law/commercial-6.jpg";
import commercialimg7 from "../../assets/Services/commercial-law/commercial-7.jpg";
import commercialimg8 from "../../assets/Services/commercial-law/commercial-8.jpg";

// RERA Matters Images
import reraimg1 from "../../assets/Services/rera-matters/rare-1.jpg";
import reraimg2 from "../../assets/Services/rera-matters/rare-2.jpg";
import reraimg3 from "../../assets/Services/rera-matters/rare-3.jpg";
import reraimg4 from "../../assets/Services/rera-matters/rare-4.jpg";
import reraimg5 from "../../assets/Services/rera-matters/rare-5.jpg";
import reraimg6 from "../../assets/Services/rera-matters/rare-6.jpg";
import reraimg7 from "../../assets/Services/rera-matters/rare-7.jpg";
import reraimg8 from "../../assets/Services/rera-matters/rare-8.jpg";

// Cheque Bounce Cases Images
import chequeimg1 from "../../assets/Services/cheque-bounce-cases/cheque-1.jpg";
import chequeimg2 from "../../assets/Services/cheque-bounce-cases/cheque-2.jpg";
import chequeimg3 from "../../assets/Services/cheque-bounce-cases/cheque-3.jpg";
import chequeimg4 from "../../assets/Services/cheque-bounce-cases/cheque-4.jpg";
import chequeimg5 from "../../assets/Services/cheque-bounce-cases/cheque-5.jpg";
import chequeimg6 from "../../assets/Services/cheque-bounce-cases/cheque-6.jpg";
import chequeimg7 from "../../assets/Services/cheque-bounce-cases/cheque-7.jpg";
import chequeimg8 from "../../assets/Services/cheque-bounce-cases/cheque-8.jpg";

// Constitutional Matters Images
import constitutionalimg1 from "../../assets/Services/constitutional-law/constitutional-1.jpg";
import constitutionalimg2 from "../../assets/Services/constitutional-law/constitutional-2.jpg";
import constitutionalimg3 from "../../assets/Services/constitutional-law/constitutional-3.jpg";
import constitutionalimg4 from "../../assets/Services/constitutional-law/constitutional-4.jpg";
import constitutionalimg5 from "../../assets/Services/constitutional-law/constitutional-5.jpg";
import constitutionalimg6 from "../../assets/Services/constitutional-law/constitutional-6.jpg";
import constitutionalimg7 from "../../assets/Services/constitutional-law/constitutional-7.jpg";
import constitutionalimg8 from "../../assets/Services/constitutional-law/constitutional-8.jpg";

// Banking & Finance Matters Images
import bankingimg1 from "../../assets/Services/banking-finance/banking-1.jpg";
import bankingimg2 from "../../assets/Services/banking-finance/banking-2.jpg";
import bankingimg3 from "../../assets/Services/banking-finance/banking-3.jpg";
import bankingimg4 from "../../assets/Services/banking-finance/banking-4.jpg";
import bankingimg5 from "../../assets/Services/banking-finance/banking-5.jpg";
import bankingimg6 from "../../assets/Services/banking-finance/banking-6.jpg";
import bankingimg7 from "../../assets/Services/banking-finance/banking-7.jpg";
import bankingimg8 from "../../assets/Services/banking-finance/banking-8.jpg";

// IBC Matters Images
import ibcimg1 from "../../assets/Services/ibc-matters/ibc-1.jpg";
import ibcimg2 from "../../assets/Services/ibc-matters/ibc-2.jpg";
import ibcimg3 from "../../assets/Services/ibc-matters/ibc-3.jpg";
import ibcimg4 from "../../assets/Services/ibc-matters/ibc-4.jpg";
import ibcimg5 from "../../assets/Services/ibc-matters/ibc-5.jpg";
import ibcimg6 from "../../assets/Services/ibc-matters/ibc-6.jpg";
import ibcimg7 from "../../assets/Services/ibc-matters/ibc-7.jpg";
import ibcimg8 from "../../assets/Services/ibc-matters/ibc-8.jpg";

// Cyber Matters Images
import cyberimg1 from "../../assets/Services/cyber-matters/cyber-1.jpg";
import cyberimg2 from "../../assets/Services/cyber-matters/cyber-2.jpg";
import cyberimg3 from "../../assets/Services/cyber-matters/cyber-3.jpg";
import cyberimg4 from "../../assets/Services/cyber-matters/cyber-4.jpg";
import cyberimg5 from "../../assets/Services/cyber-matters/cyber-5.jpg";
import cyberimg6 from "../../assets/Services/cyber-matters/cyber-6.jpg";
import cyberimg7 from "../../assets/Services/cyber-matters/cyber-7.jpg";
import cyberimg8 from "../../assets/Services/cyber-matters/cyber-8.jpg";

// Environmental Matters Images
import envimg1 from "../../assets/Services/environmental-matters/envirment-1.jpg";
import envimg2 from "../../assets/Services/environmental-matters/envirment-2.jpg";
import envimg3 from "../../assets/Services/environmental-matters/envirment-3.jpg";
import envimg4 from "../../assets/Services/environmental-matters/envirment-4.jpg";
import envimg5 from "../../assets/Services/environmental-matters/envirment-5.jpg";
import envimg6 from "../../assets/Services/environmental-matters/envirment-6.jpg";
import envimg7 from "../../assets/Services/environmental-matters/envirment-7.jpg";
import envimg8 from "../../assets/Services/environmental-matters/envirment-8.jpg";

// Arbitration & Mediation Images
import arbimg1 from "../../assets/Services/arbitration-mediation/arbitration-1.jpg";
import arbimg2 from "../../assets/Services/arbitration-mediation/arbitration-2.jpg";
import arbimg3 from "../../assets/Services/arbitration-mediation/arbitration-3.jpg";
import arbimg4 from "../../assets/Services/arbitration-mediation/arbitration-4.jpg";
import arbimg5 from "../../assets/Services/arbitration-mediation/arbitration-5.jpg";
import arbimg6 from "../../assets/Services/arbitration-mediation/arbitration-6.jpg";
import arbimg7 from "../../assets/Services/arbitration-mediation/arbitration-7.jpg";
import arbimg8 from "../../assets/Services/arbitration-mediation/arbitration-8.jpg";

// Company Matters Images
import cpimg1 from "../../assets/Services/company-matters/company-1.jpg";
import cpimg2 from "../../assets/Services/company-matters/company-2.jpg";
import cpimg3 from "../../assets/Services/company-matters/company-3.jpg";
import cpimg4 from "../../assets/Services/company-matters/company-4.jpg";
import cpimg5 from "../../assets/Services/company-matters/company-5.jpg";
import cpimg6 from "../../assets/Services/company-matters/company-6.jpg";
import cpimg7 from "../../assets/Services/company-matters/company-7.jpg";
import cpimg8 from "../../assets/Services/company-matters/company-8.jpg";

// Human Rights / PILs Images
import humanimg1 from "../../assets/Services/human-rights-pils/humanright-1.jpg";
import humanimg2 from "../../assets/Services/human-rights-pils/humanright-2.jpg";
import humanimg3 from "../../assets/Services/human-rights-pils/humanright-3.jpg";
import humanimg4 from "../../assets/Services/human-rights-pils/humanright-4.jpg";
import humanimg5 from "../../assets/Services/human-rights-pils/humanright-5.jpg";
import humanimg6 from "../../assets/Services/human-rights-pils/humanright-6.jpg";
import humanimg7 from "../../assets/Services/human-rights-pils/humanright-7.jpg";
import humanimg8 from "../../assets/Services/human-rights-pils/humanright-8.jpg";

export const servicesData = [

 {
  id: "civil-cases",

  title: "Civil Cases",

  bannerImage: civilimg2,

  shortDesc:
    "Expert handling of property disputes, contract enforcement, and consumer rights with strategic legal solutions.",

  fullDesc: {
    intro:
      "We provide comprehensive civil litigation services tailored to address a wide range of legal disputes with precision, strategy, and dedication. Our team focuses on delivering practical and result-oriented legal solutions while ensuring complete transparency and client satisfaction throughout the legal process.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our expertise covers property disputes, where we assist clients in resolving ownership conflicts, title issues, and boundary disagreements through effective legal strategies. We also handle injunction matters, ensuring timely relief to protect our clients’ rights and interests. With a strong understanding of civil laws, we aim to minimize risks and deliver efficient outcomes.",
      },

      {
        title: "Financial & Property Matters",
        list: [
          "Recovery suits for outstanding dues and financial claims",
          "Partition suits for division of jointly owned property",
          "Execution petitions to enforce court decrees effectively",
          "Handling ownership conflicts and title disputes",
          "Legal due diligence for property transactions",
          "Advisory on land acquisition and property investments",
        ],
      },

      {
        title: "Contract & Legal Enforcement",
        list: [
          "Specific performance cases to enforce agreements",
          "Legal action for breach of contract",
          "Ensuring contractual obligations are fulfilled",
          "Strategic legal representation in disputes",
          "Drafting and reviewing legal contracts",
          "Negotiation and dispute resolution support",
        ],
      },

      {
        title: "Rental & Consumer Protection",
        list: [
          "Rent and eviction disputes for landlords and tenants",
          "Legal assistance in tenancy agreements",
          "Consumer protection cases for unfair practices",
          "Compensation claims for service deficiencies",
          "Representation before consumer forums",
          "Handling builder-buyer disputes and delays",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Initial consultation and case understanding",
          "Detailed case evaluation and documentation",
          "Legal notice drafting and pre-litigation strategy",
          "Filing and legal proceedings",
          "Strong court representation",
          "Continuous case updates and client communication",
          "Final resolution and enforcement",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with a client-centric approach to deliver reliable and effective solutions. Our team ensures timely communication, strategic planning, and strong courtroom representation. We prioritize ethical practices, confidentiality, and a results-driven methodology to achieve the best possible outcomes for our clients.",
      },

      {
        title: "Industries We Serve",
        list: [
          "Real estate and property sector",
          "Small and medium enterprises (SMEs)",
          "Corporate and business entities",
          "Individual clients and families",
          "Startups and entrepreneurs",
        ],
      },
    ],
  },

  icon: "⚖️",

  featureDetails: [
    {
      name: "Property Disputes",
      img: civilimg1,
      desc: "Expert handling of land ownership and title deed conflicts. We ensure proper legal resolution through thorough documentation and representation.",
    },
    {
      name: "Injunctions",
      img: civilimg2,
      desc: "Securing immediate court orders to prevent illegal actions. Our team acts quickly to safeguard your rights and interests.",
    },
    {
      name: "Recovery Suits",
      img: civilimg3,
      desc: "Legal action for recovery of outstanding debts and dues. We follow a strategic approach to ensure timely and effective recovery.",
    },
    {
      name: "Partition Suits",
      img: civilimg4,
      desc: "Legal division of ancestral or joint properties among heirs. We handle disputes carefully to achieve fair and lawful distribution.",
    },
    {
      name: "Specific Performance",
      img: civilimg5,
      desc: "Enforcing contractual obligations through court mandates. We ensure agreements are honored as per legal provisions.",
    },
    {
      name: "Rent & Eviction",
      img: civilimg6,
      desc: "Resolving landlord-tenant disputes and eviction processes. We provide balanced legal support for both parties involved.",
    },
    {
      name: "Consumer Law",
      img: civilimg7,
      desc: "Protecting rights against unfair trade practices and services. We help clients seek compensation and justice effectively.",
    },
    {
      name: "Execution Petitions",
      img: civilimg8,
      desc: "Implementing court decrees to ensure justice is served. Our team ensures proper enforcement without unnecessary delays.",
    },
  ],

  helmetTitle: "Civil Litigation Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore our Civil Litigation services at Advocate Saurav Dagar Chambers. Experienced lawyers providing trusted legal solutions in property, contract, and civil disputes with a client-first approach.",

  helmetKeywords:
    "Civil Litigation, Advocate Saurav Dagar, Legal Services, Property Disputes, Contract Disputes, Consumer Law, Attorneys, Civil Lawyers India",

  helmetnoscript:
    "Please enable JavaScript to view this Civil Litigation service page properly.",
},

 {
  id: "criminal-cases",

  title: "Criminal Cases",

  bannerImage: criminalimg2,

  shortDesc:
    "Expert defense in bail matters, criminal trials, and white-collar crimes with strategic legal representation.",

  fullDesc: {
    intro:
      "We provide comprehensive criminal litigation services focused on protecting the rights and liberty of our clients. From pre-arrest protection to trial and appellate advocacy, our team ensures a strong, strategic, and result-driven defense at every stage of the criminal justice process.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our criminal law practice covers a wide range of offenses under the Indian Penal Code and special laws. We represent clients in bail matters, trial proceedings, and appeals while ensuring procedural safeguards and legal rights are strictly upheld. Our approach combines legal precision with practical courtroom strategy.",
      },

      {
        title: "Bail & Pre-Arrest Protection",
        list: [
          "Regular bail applications in trial and sessions courts",
          "Anticipatory bail for protection against arrest",
          "Urgent bail hearings and interim relief",
          "Handling non-bailable offences effectively",
          "Legal strategy for bail rejection cases",
        ],
      },

      {
        title: "Trial & Court Representation",
        list: [
          "Comprehensive defense in criminal trials",
          "Cross-examination and evidence handling",
          "Representation before Magistrate and Sessions Courts",
          "Strategic case building and argument drafting",
          "Protection of constitutional and legal rights",
        ],
      },

      {
        title: "High Court & Appellate Matters",
        list: [
          "FIR quashing petitions under Section 482 CrPC",
          "Criminal appeals against conviction or sentencing",
          "Revision petitions and legal challenges",
          "Representation in High Court and Supreme Court",
          "Stay orders and interim relief applications",
        ],
      },

      {
        title: "Specialized Criminal Matters",
        list: [
          "White-collar crimes and financial fraud cases",
          "Cybercrime cases including hacking and data theft",
          "Corporate criminal liability matters",
          "Economic offences and investigation support",
          "Legal defense in complex multi-agency cases",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Confidential case assessment and consultation",
          "Detailed evidence review and legal strategy",
          "Pre-arrest and post-arrest legal planning",
          "Aggressive and strategic court representation",
          "Regular updates and transparent communication",
          "Final resolution and appellate support if required",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We understand the sensitivity and urgency of criminal matters. Our team ensures quick action, confidentiality, and strong courtroom advocacy. With a focus on protecting individual rights and achieving the best possible outcomes, we provide reliable and result-oriented criminal defense services.",
      },

      {
        title: "Clients We Represent",
        list: [
          "Individuals facing criminal charges",
          "Corporate professionals and executives",
          "Business owners and entrepreneurs",
          "Startups and organizations",
          "Clients in high-stakes and sensitive matters",
        ],
      },
    ],
  },

  icon: "🏛️",

  featureDetails: [
    {
      name: "Regular Bail",
      img: criminalimg1,
      desc: "Representation for securing release during investigation or trial. We ensure timely filing and strong legal arguments for bail approval.",
    },
    {
      name: "Anticipatory Bail",
      img: criminalimg2,
      desc: "Legal protection against potential arrest in non-bailable offences. Our team prepares proactive strategies to safeguard your liberty.",
    },
    {
      name: "Trial Advocacy",
      img: criminalimg3,
      desc: "Comprehensive defense throughout the criminal trial process. We handle evidence, arguments, and courtroom strategy effectively.",
    },
    {
      name: "FIR Quashing",
      img: criminalimg4,
      desc: "Petitions before High Courts to quash meritless criminal proceedings. We ensure misuse of law is challenged legally.",
    },
    {
      name: "Criminal Appeals",
      img: criminalimg5,
      desc: "Challenging convictions in Sessions, High Courts & Supreme Court. We focus on reversing unjust decisions through strong legal grounds.",
    },
    {
      name: "White Collar Crimes",
      img: criminalimg6,
      desc: "Handling complex corporate fraud and financial investigations. We provide strategic defense in high-value cases.",
    },
    {
      name: "Cyber Crimes",
      img: criminalimg7,
      desc: "Defense in matters of data theft, hacking, and online fraud. We handle modern digital crime cases with technical understanding.",
    },
    {
      name: "Police Custody Help",
      img: criminalimg8,
      desc: "Legal assistance during police interrogation and custody. We ensure your rights are protected at every stage.",
    },
  ],

  helmetTitle: "Criminal Litigation Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore our Criminal Litigation services at Advocate Saurav Dagar Chambers. Expert criminal lawyers providing strong defense in bail, trials, cybercrime, and white-collar cases.",

  helmetKeywords:
    "Criminal Litigation, Advocate Saurav Dagar, Criminal Lawyer, Bail, FIR Quashing, Cyber Crime, White Collar Crime, Legal Defense India",

  helmetnoscript:
    "Please enable JavaScript to view this Criminal Litigation service page properly.",
},

{
  id: "matrimonial-Cases",

  title: "Matrimonial Cases",

  bannerImage: matrimonialimg3,

  shortDesc:
    "Sensitive handling of divorce, child custody, and family disputes with a compassionate and strategic legal approach.",

  fullDesc: {
    intro:
      "We provide comprehensive matrimonial and family law services with a focus on sensitivity, confidentiality, and practical solutions. Understanding the emotional and legal complexities involved, our team ensures a balanced approach to protect your rights while aiming for fair and amicable resolutions wherever possible.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our matrimonial practice covers divorce, maintenance, child custody, and domestic violence matters. We handle both mutual and contested cases with a strong legal strategy while ensuring minimal emotional stress for our clients. Our goal is to secure fair outcomes while maintaining dignity and confidentiality.",
      },

      {
        title: "Divorce & Separation Matters",
        list: [
          "Mutual consent divorce with fast-track resolution",
          "Contested divorce cases with strong representation",
          "Judicial separation and legal notices",
          "Drafting and filing of divorce petitions",
          "Handling complex marital disputes and litigation",
        ],
      },

      {
        title: "Child Custody & Family Rights",
        list: [
          "Child custody and visitation rights cases",
          "Ensuring welfare and best interests of the child",
          "Guardianship and parental rights matters",
          "Modification of custody arrangements",
          "Negotiation and mediation in family disputes",
        ],
      },

      {
        title: "Maintenance & Financial Matters",
        list: [
          "Maintenance cases under Section 125 CrPC",
          "Alimony and financial settlement negotiations",
          "Interim maintenance applications",
          "Enforcement of maintenance orders",
          "Financial rights protection for spouses",
        ],
      },

      {
        title: "Protection & Legal Remedies",
        list: [
          "Domestic violence cases under DV Act",
          "Protection orders and residence rights",
          "Dowry harassment and cruelty cases",
          "Filing complaints and legal defense",
          "Immediate legal relief in urgent situations",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Confidential consultation and case understanding",
          "Emotional and legal support throughout the process",
          "Strategic legal planning and documentation",
          "Encouraging mediation and settlement where possible",
          "Strong courtroom representation when required",
          "Timely updates and transparent communication",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We understand that matrimonial disputes are deeply personal and emotionally challenging. Our team ensures a compassionate approach combined with strong legal expertise. We focus on protecting your rights, maintaining confidentiality, and achieving fair and practical outcomes.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals seeking divorce or separation",
          "Parents involved in custody disputes",
          "Spouses seeking maintenance or alimony",
          "Victims of domestic violence or harassment",
          "Families seeking peaceful dispute resolution",
        ],
      },
    ],
  },

  icon: "🏠",

  featureDetails: [
    {
      name: "Mutual Divorce",
      img: matrimonialimg1,
      desc: "Fast-track dissolution of marriage with mutual agreement. We ensure smooth documentation and minimal legal complications.",
    },
    {
      name: "Contested Divorce",
      img: matrimonialimg2,
      desc: "Strong representation in complex disputed divorce cases. We build strategic arguments to protect your rights.",
    },
    {
      name: "Child Custody",
      img: matrimonialimg3,
      desc: "Protecting parental rights and ensuring the child's welfare. We prioritize the best interests of the child.",
    },
    {
      name: "Alimony Matters",
      img: matrimonialimg4,
      desc: "Legal support for fair financial maintenance and settlements. We ensure equitable outcomes for both parties.",
    },
    {
      name: "Domestic Violence",
      img: matrimonialimg5,
      desc: "Protection orders and litigation under the DV Act. We provide immediate legal relief and strong representation.",
    },
    {
      name: "Annulment",
      img: matrimonialimg6,
      desc: "Legal petitions for declaring a marriage null and void. We handle cases with sensitivity and legal precision.",
    },
    {
      name: "Restitution of Rights",
      img: matrimonialimg7,
      desc: "Legal steps for the reconciliation of separated spouses. We guide clients through lawful restoration processes.",
    },
    {
      name: "Family Counseling",
      img: matrimonialimg8,
      desc: "Mediation services to resolve family disputes amicably. We aim to reduce conflict through structured discussions.",
    },
  ],

  helmetTitle: "Matrimonial & Family Law Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Matrimonial and Family Law services at Advocate Saurav Dagar Chambers. Expert lawyers providing trusted legal support in divorce, custody, alimony, and domestic disputes.",

  helmetKeywords:
    "Matrimonial Cases, Family Law, Divorce Lawyer, Child Custody, Alimony, Domestic Violence, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Matrimonial Matters service page properly.",
},

  {
  id: "domestic-violence",

  title: "Domestic Violence",

  bannerImage: commercialimg2,

  shortDesc:
    "Specialized legal support for domestic violence cases, protection orders, and victim safety.",

  fullDesc: {
    intro:
      "We provide dedicated legal assistance to individuals facing domestic violence, ensuring their safety, dignity, and legal protection. Our approach focuses on immediate relief, long-term security, and strong legal representation.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our services cover all aspects of domestic violence law, including protection orders, legal representation, and counseling support. We work to ensure victims receive justice and protection under the law.",
      },

      {
        title: "Protection & Legal Remedies",
        list: [
          "Filing domestic violence complaints",
          "Obtaining protection and restraining orders",
          "Residence and shelter rights",
          "Monetary relief and compensation claims",
          "Child custody and support matters",
        ],
      },

      {
        title: "Legal Representation",
        list: [
          "Representation in domestic violence courts",
          "Handling police complaints and FIRs",
          "Court hearings and legal proceedings",
          "Assistance in evidence and documentation",
          "Strong advocacy for victim rights",
        ],
      },

      {
        title: "Safety & Support",
        list: [
          "Guidance on immediate safety measures",
          "Coordination with protection officers",
          "Support for shelter and safe housing",
          "Legal counseling and awareness",
          "Confidential handling of sensitive cases",
        ],
      },

      {
        title: "Financial & Custody Matters",
        list: [
          "Maintenance and financial support claims",
          "Child custody and visitation rights",
          "Medical and emergency expenses",
          "Compensation for mental and physical harm",
          "Recovery of dowry or personal assets",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding the sensitivity of each case",
          "Providing immediate legal guidance",
          "Ensuring quick legal protection",
          "Strategic handling of court proceedings",
          "Maintaining confidentiality and respect",
          "Focusing on long-term safety and justice",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We handle domestic violence cases with utmost sensitivity, confidentiality, and dedication. Our goal is to protect victims, ensure justice, and provide strong legal support during difficult times.",
      },

      {
        title: "Who We Help",
        list: [
          "Victims of domestic violence",
          "Women seeking legal protection",
          "Individuals facing abuse or harassment",
          "Families dealing with domestic disputes",
          "Clients seeking safety and legal support",
        ],
      },
    ],
  },

  icon: "🛡️",

  featureDetails: [
    {
      name: "Protection Orders",
      img: commercialimg1,
      desc: "Legal assistance in obtaining restraining and protection orders to ensure safety.",
    },
    {
      name: "Court Representation",
      img: commercialimg2,
      desc: "Strong representation in domestic violence cases before courts.",
    },
    {
      name: "Police Assistance",
      img: commercialimg3,
      desc: "Support in filing complaints and coordinating with law enforcement.",
    },
    {
      name: "Financial Support",
      img: commercialimg4,
      desc: "Helping secure maintenance and financial compensation.",
    },
    {
      name: "Child Custody",
      img: commercialimg5,
      desc: "Legal help in custody and child protection matters.",
    },
    {
      name: "Shelter Rights",
      img: commercialimg6,
      desc: "Ensuring safe residence and housing rights for victims.",
    },
    {
      name: "Legal Counseling",
      img: commercialimg7,
      desc: "Guidance and support through every stage of the case.",
    },
    {
      name: "Confidential Handling",
      img: commercialimg8,
      desc: "Maintaining complete privacy and sensitivity in all matters.",
    },
  ],

  helmetTitle: "Domestic Violence Legal Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Get expert legal support for domestic violence cases at Advocate Saurav Dagar Chambers. We provide protection orders, legal representation, and victim safety services.",

  helmetKeywords:
    "Domestic Violence Law, Protection Orders, Legal Help for Abuse Victims, Women Safety Law, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Domestic Violence service page properly.",
},


  {
  id: "partnership-matters",

  title: "Partnership Matters",

  bannerImage: reraimg3,

  shortDesc:
    "Expert legal support in partnership disputes, agreements, and business conflict resolution.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services for partnership and business-related matters, ensuring smooth operations, dispute resolution, and protection of partner rights. Our approach focuses on clear legal structuring, risk minimization, and effective dispute handling.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers partnership formation, disputes between partners, dissolution, and financial settlements. We assist businesses in drafting strong agreements and resolving conflicts through legal and strategic methods to safeguard long-term interests.",
      },

      {
        title: "Partnership Formation & Agreements",
        list: [
          "Drafting partnership deeds and agreements",
          "Business structure advisory and legal setup",
          "Defining roles, rights, and responsibilities",
          "Profit-sharing and liability clauses",
          "Registration of partnership firms",
        ],
      },

      {
        title: "Dispute Resolution",
        list: [
          "Handling disputes between partners",
          "Breach of partnership agreements",
          "Mismanagement and fiduciary duty issues",
          "Mediation and negotiation support",
          "Legal action for unresolved conflicts",
        ],
      },

      {
        title: "Financial & Exit Matters",
        list: [
          "Settlement of accounts between partners",
          "Dissolution of partnership firms",
          "Exit strategies and partner retirement",
          "Asset distribution and liability handling",
          "Recovery of dues and financial claims",
        ],
      },

      {
        title: "Compliance & Legal Protection",
        list: [
          "Ensuring regulatory compliance",
          "Legal documentation and record maintenance",
          "Protection against fraudulent practices",
          "Advisory on tax and financial liabilities",
          "Risk assessment and legal audits",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding business structure and issues",
          "Detailed legal evaluation and documentation",
          "Strategic dispute resolution planning",
          "Negotiation and settlement where possible",
          "Strong legal representation when required",
          "Ensuring smooth closure and compliance",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with a practical business understanding to resolve partnership matters efficiently. Our focus is on minimizing disputes, protecting financial interests, and ensuring long-term stability for businesses.",
      },

      {
        title: "Who We Help",
        list: [
          "Partnership firms and business owners",
          "Startup founders and co-founders",
          "Investors and stakeholders",
          "Partners facing disputes or exit issues",
          "Businesses requiring legal structuring",
        ],
      },
    ],
  },

  icon: "🤝",

  featureDetails: [
    {
      name: "Partnership Agreements",
      img: reraimg1,
      desc: "Drafting clear and legally strong partnership deeds. We ensure roles and responsibilities are well-defined.",
    },
    {
      name: "Partner Disputes",
      img: reraimg2,
      desc: "Resolving conflicts between partners effectively. We aim for fair and practical legal solutions.",
    },
    {
      name: "Business Dissolution",
      img: reraimg3,
      desc: "Legal assistance in closing partnership firms. We ensure proper settlement of liabilities and assets.",
    },
    {
      name: "Profit Sharing Issues",
      img: reraimg4,
      desc: "Handling disputes related to profit distribution. We protect financial rights of partners.",
    },
    {
      name: "Breach of Agreement",
      img: reraimg5,
      desc: "Legal action against violation of partnership terms. We ensure accountability and legal enforcement.",
    },
    {
      name: "Partner Exit",
      img: reraimg6,
      desc: "Smooth exit and retirement planning for partners. We handle settlements and legal documentation.",
    },
    {
      name: "Compliance Support",
      img: reraimg7,
      desc: "Ensuring adherence to legal and regulatory requirements. We help businesses stay legally secure.",
    },
    {
      name: "Financial Settlements",
      img: reraimg8,
      desc: "Handling financial claims and account settlements. We ensure transparent and lawful resolution.",
    },
  ],

  helmetTitle: "Partnership Law Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Partnership Law services at Advocate Saurav Dagar Chambers. Expert legal support for partnership agreements, disputes, dissolution, and business conflicts.",

  helmetKeywords:
    "Partnership Law, Business Disputes, Partnership Agreement, Firm Dissolution, Legal Services India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Partnership Matters service page properly.",
},
 {
  id: "recovery-of-money",

  title: "Recovery of Money",

  bannerImage: chequeimg2,

  shortDesc:
    "Effective legal solutions for recovery of dues, cheque bounce cases, and financial disputes with swift action.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services for the recovery of money, including cheque bounce cases under the Negotiable Instruments Act and civil recovery suits. Our approach focuses on quick legal action, strategic planning, and maximizing recovery while minimizing delays.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our team specializes in handling cheque dishonor cases under Section 138 of the NI Act along with civil recovery mechanisms. We ensure proper legal procedures, timely filings, and strong representation to secure favorable outcomes for our clients.",
      },

      {
        title: "Cheque Bounce & NI Act Matters",
        list: [
          "Issuing legal notice within statutory timelines",
          "Filing complaints under Section 138 NI Act",
          "Handling multiple cheque dishonor cases",
          "Representation before Magistrate Courts",
          "Ensuring compliance with legal procedures",
        ],
      },

      {
        title: "Civil Recovery Solutions",
        list: [
          "Filing summary suits for quick recovery",
          "Recovery of business and personal dues",
          "Execution of recovery decrees",
          "Attachment of assets for recovery",
          "Legal action for unpaid invoices and loans",
        ],
      },

      {
        title: "Financial Claims & Compensation",
        list: [
          "Claiming cheque amount with interest",
          "Interim compensation applications",
          "Negotiation and settlement strategies",
          "Recovery through mediation and arbitration",
          "Enforcement of court-ordered payments",
        ],
      },

      {
        title: "Defense & Legal Protection",
        list: [
          "Defense in false cheque bounce cases",
          "Challenging improper legal notices",
          "Legal strategy for acquittal",
          "Handling misuse of NI Act provisions",
          "Representation in appeals and revisions",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Case evaluation and document verification",
          "Issuing legal notice and pre-litigation strategy",
          "Filing complaints and legal proceedings",
          "Strong courtroom representation",
          "Exploring settlement opportunities",
          "Ensuring final recovery and enforcement",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We focus on fast, efficient, and result-oriented recovery solutions. With strong expertise in both criminal and civil recovery mechanisms, we ensure maximum recovery with minimum delay while maintaining professional and transparent communication.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals seeking recovery of personal loans",
          "Businesses facing payment defaults",
          "Vendors and service providers",
          "Financial institutions and lenders",
          "Clients involved in cheque bounce disputes",
        ],
      },
    ],
  },

  icon: "🖋️",

  featureDetails: [
    {
      name: "Legal Notice",
      img: chequeimg1,
      desc: "Drafting the mandatory 15-day notice for cheque dishonor. We ensure compliance with all legal requirements.",
    },
    {
      name: "Sec 138 Complaint",
      img: chequeimg2,
      desc: "Filing criminal complaints in Magistrate courts. We handle complete documentation and court procedures.",
    },
    {
      name: "Summary Suits",
      img: chequeimg3,
      desc: "Civil recovery suits alongside criminal proceedings. We aim for faster recovery through dual legal action.",
    },
    {
      name: "Evidence Filing",
      img: chequeimg4,
      desc: "Submitting bank memos and original documents as proof. We ensure strong evidentiary support.",
    },
    {
      name: "Interim Compensation",
      img: chequeimg5,
      desc: "Securing up to 20% of cheque amount during trial. We help clients get early financial relief.",
    },
    {
      name: "Mediation",
      img: chequeimg6,
      desc: "Settling cheque disputes through court-led mediation. We aim for quick and amicable resolution.",
    },
    {
      name: "Defense Counsel",
      img: chequeimg7,
      desc: "Representing clients falsely accused in cheque cases. We build strong legal defense strategies.",
    },
    {
      name: "Appeals",
      img: chequeimg8,
      desc: "Filing or defending appeals against cheque case judgments. We ensure proper legal follow-up.",
    },
  ],

  helmetTitle: "Recovery of Money & Cheque Bounce Cases - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Recovery of Money and Cheque Bounce services at Advocate Saurav Dagar Chambers. Expert legal support for NI Act cases, financial disputes, and fast recovery solutions.",

  helmetKeywords:
    "Cheque Bounce Lawyer, Section 138 NI Act, Money Recovery, Legal Notice, Financial Disputes, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Recovery of Money service page properly.",
},

 {
  id: "constitutional-law",

  title: "Constitutional Matters",

  bannerImage: constitutionalimg2,

  shortDesc:
    "Expert legal support for constitutional rights, writ petitions, and protection against arbitrary state actions.",

  fullDesc: {
    intro:
      "We specialize in Constitutional law, offering strong legal representation in High Courts and the Supreme Court. Our focus is on protecting fundamental rights, challenging unlawful state actions, and ensuring justice through constitutional remedies.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers a wide range of constitutional matters including writ petitions, public interest litigation, and challenges against government actions. We ensure that individual and institutional rights are protected under the Constitution.",
      },

      {
        title: "Writ Petitions",
        list: [
          "Writ of Habeas Corpus for unlawful detention",
          "Writ of Mandamus against non-performance of duty",
          "Writ of Certiorari to quash illegal orders",
          "Writ of Prohibition against excess jurisdiction",
          "Writ of Quo-Warranto challenging public office authority",
        ],
      },

      {
        title: "Fundamental Rights Protection",
        list: [
          "Protection against violation of basic rights",
          "Freedom of speech and expression cases",
          "Right to life and personal liberty matters",
          "Equality and anti-discrimination cases",
          "Legal remedies against state excesses",
        ],
      },

      {
        title: "Public Interest Litigation",
        list: [
          "Filing PILs for social justice",
          "Challenging unconstitutional laws",
          "Government accountability cases",
          "Environmental and public welfare issues",
          "Representation in higher judiciary",
        ],
      },

      {
        title: "Service & Administrative Matters",
        list: [
          "Government employment disputes",
          "Unlawful termination challenges",
          "Promotion and service-related issues",
          "Disciplinary action cases",
          "Administrative law remedies",
        ],
      },

      {
        title: "Election & Governance Matters",
        list: [
          "Election petitions and disputes",
          "Challenging election results",
          "Governance and policy-related cases",
          "Misuse of power by authorities",
          "Legal scrutiny of public offices",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Thorough constitutional analysis",
          "Strong legal drafting of petitions",
          "Strategic litigation planning",
          "Effective representation in courts",
          "Focus on protecting fundamental rights",
          "Ensuring timely and impactful outcomes",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine deep constitutional knowledge with practical litigation experience. Our team is committed to defending rights, challenging injustice, and delivering strong legal outcomes in complex constitutional matters.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals facing rights violations",
          "Government employees",
          "Organizations and institutions",
          "Public interest groups and NGOs",
          "Citizens seeking constitutional remedies",
        ],
      },
    ],
  },

  icon: "📜",

  featureDetails: [
    {
      name: "Habeas Corpus",
      img: constitutionalimg1,
      desc: "Legal action against unlawful detention ensuring immediate relief and liberty.",
    },
    {
      name: "Mandamus",
      img: constitutionalimg2,
      desc: "Court direction to public authorities to perform their legal duties.",
    },
    {
      name: "Certiorari",
      img: constitutionalimg3,
      desc: "Quashing illegal orders passed by lower courts or authorities.",
    },
    {
      name: "PIL Advocacy",
      img: constitutionalimg4,
      desc: "Filing Public Interest Litigations for justice and legal reform.",
    },
    {
      name: "Fundamental Rights",
      img: constitutionalimg5,
      desc: "Protection against violation of constitutional rights by the State.",
    },
    {
      name: "Service Matters",
      img: constitutionalimg6,
      desc: "Handling disputes related to government employment and service law.",
    },
    {
      name: "Quo Warranto",
      img: constitutionalimg7,
      desc: "Challenging illegal occupation of public office.",
    },
    {
      name: "Election Petitions",
      img: constitutionalimg8,
      desc: "Legal challenges to election results and electoral disputes.",
    },
  ],

  helmetTitle: "Constitutional Law Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Expert Constitutional Law services at Advocate Saurav Dagar Chambers. We handle writ petitions, fundamental rights protection, and legal challenges against state actions.",

  helmetKeywords:
    "Constitutional Law India, Writ Petitions, Fundamental Rights, PIL, Legal Services, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Constitutional Matters service page properly.",
},

 {
  id: "banking-finance",

  title: "Banking & Finance",

  bannerImage: bankingimg2,

  shortDesc:
    "Comprehensive legal support for banking disputes, loan defaults, DRT matters, and financial compliance.",

  fullDesc: {
    intro:
      "We provide expert legal services in banking and financial matters, representing clients in complex disputes involving loans, recovery, and regulatory compliance. Our approach focuses on protecting financial interests and ensuring lawful resolution of disputes.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice includes representation before Debt Recovery Tribunals (DRT), handling SARFAESI proceedings, and advising on financial disputes. We assist both lenders and borrowers in resolving complex banking issues effectively.",
      },

      {
        title: "Debt Recovery & DRT Matters",
        list: [
          "Representation before Debt Recovery Tribunal (DRT)",
          "Filing and defending recovery applications",
          "Execution of recovery certificates",
          "Handling appeals before DRAT",
          "Legal strategy for loan recovery cases",
        ],
      },

      {
        title: "SARFAESI Act Proceedings",
        list: [
          "Defense against property attachment notices",
          "Challenging bank actions under SARFAESI",
          "Assistance in possession and auction matters",
          "Legal remedies for borrowers",
          "Ensuring due process compliance",
        ],
      },

      {
        title: "Loan & Credit Disputes",
        list: [
          "Resolution of loan default disputes",
          "Credit score and reporting issues",
          "Unfair banking practices",
          "Settlement and restructuring advice",
          "Negotiation with financial institutions",
        ],
      },

      {
        title: "Fraud & Financial Irregularities",
        list: [
          "Defense in bank fraud allegations",
          "Handling financial scam cases",
          "Regulatory compliance advisory",
          "Internal investigation support",
          "Legal representation in criminal proceedings",
        ],
      },

      {
        title: "Asset & Mortgage Matters",
        list: [
          "Disputes related to mortgaged properties",
          "Title and asset verification issues",
          "Enforcement of security interests",
          "Asset recovery and possession cases",
          "Legal due diligence",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Detailed financial and legal assessment",
          "Strategic dispute resolution planning",
          "Negotiation with banks and institutions",
          "Strong courtroom representation",
          "Focus on minimizing financial risk",
          "Ensuring compliance with regulations",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine deep knowledge of banking laws with practical litigation experience. Our goal is to protect clients from financial risks, resolve disputes efficiently, and ensure compliance with evolving financial regulations.",
      },

      {
        title: "Who We Help",
        list: [
          "Borrowers facing loan recovery actions",
          "Banks and financial institutions",
          "Businesses with financial disputes",
          "Individuals facing credit issues",
          "Clients involved in fraud or compliance matters",
        ],
      },
    ],
  },

  icon: "💰",

  featureDetails: [
    {
      name: "DRT Litigation",
      img: bankingimg1,
      desc: "Expert representation in Debt Recovery Tribunal for loan recovery and disputes.",
    },
    {
      name: "SARFAESI Defense",
      img: bankingimg2,
      desc: "Legal support against property attachment and enforcement actions by banks.",
    },
    {
      name: "Loan Recovery",
      img: bankingimg3,
      desc: "Strategic legal assistance for recovering outstanding loans and dues.",
    },
    {
      name: "Bank Fraud Defense",
      img: bankingimg4,
      desc: "Handling cases involving financial fraud and irregularities.",
    },
    {
      name: "Credit Disputes",
      img: bankingimg5,
      desc: "Resolving credit score issues and incorrect financial reporting.",
    },
    {
      name: "Financial Arbitration",
      img: bankingimg6,
      desc: "Settling banking disputes through arbitration and alternative methods.",
    },
    {
      name: "Mortgage Disputes",
      img: bankingimg7,
      desc: "Handling legal issues related to mortgaged properties and assets.",
    },
    {
      name: "NPA Management",
      img: bankingimg8,
      desc: "Guidance on restructuring and managing Non-Performing Assets.",
    },
  ],

  helmetTitle: "Banking & Finance Legal Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Expert Banking & Finance legal services at Advocate Saurav Dagar Chambers. We handle DRT cases, SARFAESI matters, loan disputes, and financial litigation.",

  helmetKeywords:
    "Banking Law India, DRT Cases, SARFAESI Act, Loan Disputes, Financial Litigation, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Banking & Finance service page properly.",
},

{
  id: "negotiable-instrument-act-cases",

  title: "Negotiable Instrument Act Cases",

  bannerImage: ibcimg1,

  shortDesc:
    "Expert legal services for cheque bounce and financial disputes under the Negotiable Instruments Act.",

  fullDesc: {
    intro:
      "We provide comprehensive legal assistance in matters related to cheque dishonor under the Negotiable Instruments Act, 1881. Our team ensures swift legal action, proper documentation, and strong representation to secure financial recovery and protect client interests.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice focuses on handling cheque bounce cases under Section 138 of the NI Act, along with related civil recovery proceedings. We ensure strict compliance with legal timelines and procedures to maximize the chances of successful recovery.",
      },

      {
        title: "Cheque Bounce Cases",
        list: [
          "Filing complaints under Section 138 NI Act",
          "Handling multiple cheque dishonor cases",
          "Ensuring compliance with legal timelines",
          "Representation before Magistrate Courts",
          "Legal strategy for faster case resolution",
        ],
      },

      {
        title: "Legal Notice & Documentation",
        list: [
          "Drafting statutory legal notices",
          "Verification of cheque and bank documents",
          "Preparation of complaint and affidavits",
          "Evidence collection and documentation",
          "Ensuring proper legal compliance",
        ],
      },

      {
        title: "Recovery & Compensation",
        list: [
          "Recovery of cheque amount with interest",
          "Interim compensation applications",
          "Settlement and negotiation strategies",
          "Execution of court orders",
          "Financial claim enforcement",
        ],
      },

      {
        title: "Defense & Legal Protection",
        list: [
          "Defense in false cheque bounce cases",
          "Challenging invalid legal notices",
          "Legal representation for accused persons",
          "Handling misuse of NI Act provisions",
          "Appeals and revision petitions",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Case evaluation and document analysis",
          "Issuing legal notice within time limits",
          "Filing complaint and legal proceedings",
          "Strong courtroom representation",
          "Exploring settlement opportunities",
          "Ensuring final recovery and enforcement",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We focus on fast and effective recovery through strong legal action under the NI Act. Our team ensures proper handling of documentation, timely filings, and strategic representation to achieve the best possible outcome.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals facing cheque bounce issues",
          "Businesses dealing with payment defaults",
          "Vendors and service providers",
          "Financial lenders and institutions",
          "Clients involved in financial disputes",
        ],
      },
    ],
  },

  icon: "📄",

  featureDetails: [
    {
      name: "Legal Notice",
      img: ibcimg1,
      desc: "Drafting statutory notice within 15 days of cheque dishonor. We ensure compliance with all legal requirements.",
    },
    {
      name: "Sec 138 Complaint",
      img: ibcimg2,
      desc: "Filing criminal complaints in court. We handle complete legal procedures efficiently.",
    },
    {
      name: "Cheque Bounce Cases",
      img: ibcimg3,
      desc: "Handling single and multiple dishonor cases. We ensure strong legal representation.",
    },
    {
      name: "Evidence Support",
      img: ibcimg4,
      desc: "Preparing bank memos and legal documents. We build a strong evidentiary base.",
    },
    {
      name: "Interim Compensation",
      img: ibcimg5,
      desc: "Securing interim compensation during trial. We help clients get early financial relief.",
    },
    {
      name: "Settlement Support",
      img: ibcimg6,
      desc: "Negotiating settlements between parties. We aim for quick and practical resolution.",
    },
    {
      name: "Defense Counsel",
      img: ibcimg7,
      desc: "Representing accused in cheque bounce cases. We ensure fair legal defense.",
    },
    {
      name: "Appeals",
      img: ibcimg8,
      desc: "Handling appeals and revisions. We ensure continued legal protection.",
    },
  ],

  helmetTitle: "Negotiable Instrument Act Cases - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Negotiable Instrument Act services at Advocate Saurav Dagar Chambers. Expert legal support for cheque bounce cases, Section 138 matters, and financial disputes.",

  helmetKeywords:
    "Cheque Bounce, Section 138 NI Act, Negotiable Instruments Act, Legal Notice, Financial Disputes, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Negotiable Instrument Act service page properly.",
},

{
  id: "cyber-cases",

  title: "Cyber Matters",

  bannerImage: cyberimg2,

  shortDesc:
    "Expert legal services in cybercrime, data protection, and digital fraud with strong technical and legal expertise.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services in cyber law, addressing the growing challenges of digital crimes and data protection. Our team handles complex cyber disputes with a combination of legal expertise and technical understanding, ensuring effective protection and enforcement of rights.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our cyber law practice covers offenses under the Information Technology Act and related laws. We assist clients in matters such as online fraud, data breaches, cyber defamation, and digital privacy violations, ensuring strong legal protection and timely action.",
      },

      {
        title: "Cybercrime & Digital Offenses",
        list: [
          "Cases related to data theft and unauthorized access",
          "Online fraud including phishing and financial scams",
          "Identity theft and impersonation cases",
          "Cyber stalking and harassment matters",
          "Filing cybercrime complaints and FIRs",
        ],
      },

      {
        title: "IT Act & Legal Compliance",
        list: [
          "Defense under various provisions of the IT Act",
          "Advisory on cyber law compliance",
          "Handling digital evidence and investigations",
          "Legal notices and regulatory actions",
          "Representation before cybercrime authorities",
        ],
      },

      {
        title: "Data Protection & Privacy",
        list: [
          "Data breach response and legal action",
          "Privacy law compliance for organizations",
          "Advisory on data protection frameworks",
          "Handling misuse of personal information",
          "Cross-border data protection issues",
        ],
      },

      {
        title: "E-Commerce & Digital Business",
        list: [
          "Legal compliance for online businesses",
          "Drafting website terms and privacy policies",
          "Dispute resolution in e-commerce transactions",
          "Consumer complaints in digital platforms",
          "Protection of digital assets and IP",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding technical and legal aspects",
          "Detailed case evaluation and evidence review",
          "Strategic legal planning and documentation",
          "Coordination with cybercrime authorities",
          "Strong representation in legal proceedings",
          "Ensuring quick and effective resolution",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal knowledge with technological insight to handle cyber matters effectively. Our team ensures quick response, strong legal strategy, and complete confidentiality while protecting your digital rights.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals affected by cybercrime",
          "Businesses facing data breaches",
          "E-commerce platforms and startups",
          "Corporate organizations",
          "Clients requiring IT law compliance",
        ],
      },
    ],
  },

  icon: "💻",

  featureDetails: [
    {
      name: "Data Theft",
      img: cyberimg1,
      desc: "Litigation against unauthorized data access and theft. We ensure strong legal action and recovery measures.",
    },
    {
      name: "Online Fraud",
      img: cyberimg2,
      desc: "Legal action against phishing, scams, and financial fraud. We help recover losses and prosecute offenders.",
    },
    {
      name: "Cyber Defamation",
      img: cyberimg3,
      desc: "Handling online reputation damage cases. We take swift action to remove harmful content.",
    },
    {
      name: "IT Act Violations",
      img: cyberimg4,
      desc: "Defense and prosecution under IT Act provisions. We ensure proper legal compliance and representation.",
    },
    {
      name: "Digital Signatures",
      img: cyberimg5,
      desc: "Resolving disputes related to e-signatures. We ensure authenticity and legal protection.",
    },
    {
      name: "E-Commerce Law",
      img: cyberimg6,
      desc: "Legal compliance for online businesses. We help manage risks in digital transactions.",
    },
    {
      name: "Privacy Compliance",
      img: cyberimg7,
      desc: "Ensuring adherence to data protection laws. We safeguard organizational and personal data.",
    },
    {
      name: "Identity Theft",
      img: cyberimg8,
      desc: "Legal action against misuse of identity online. We protect your digital identity and rights.",
    },
  ],

  helmetTitle: "Cyber Law & Digital Crime Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Cyber Law services at Advocate Saurav Dagar Chambers. Expert legal support for cybercrime, data protection, online fraud, and IT Act compliance.",

  helmetKeywords:
    "Cyber Law, Cyber Crime Lawyer, Data Protection, IT Act, Online Fraud, Digital Law India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Cyber Matters service page properly.",
},

  {
  id: "environmental-matters",

  title: "Environmental Matters",

  bannerImage: envimg2,

  shortDesc:
    "Expert legal services in environmental compliance, NGT litigation, and ecological protection matters.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services in environmental law, focusing on regulatory compliance, dispute resolution, and ecological protection. Our team represents clients before the National Green Tribunal (NGT) and other authorities, ensuring adherence to environmental laws while safeguarding business and public interests.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers a wide range of environmental matters including pollution control, environmental clearances, and public interest litigation. We assist both individuals and organizations in navigating complex environmental regulations and legal challenges effectively.",
      },

      {
        title: "NGT & Environmental Litigation",
        list: [
          "Representation before National Green Tribunal (NGT)",
          "Filing and defending environmental appeals",
          "Challenging unlawful environmental clearances",
          "Handling environmental compliance disputes",
          "Public Interest Litigations (PILs)",
        ],
      },

      {
        title: "Compliance & Regulatory Matters",
        list: [
          "Pollution Control Board compliance (SPCB & CPCB)",
          "Environmental impact assessments (EIA)",
          "Legal notices and regulatory approvals",
          "Audit of environmental compliance",
          "Advisory for sustainable business operations",
        ],
      },

      {
        title: "Industry-Specific Environmental Issues",
        list: [
          "Waste management and disposal regulations",
          "Hazardous and biomedical waste compliance",
          "Mining and natural resource disputes",
          "Coastal Regulation Zone (CRZ) matters",
          "Construction and infrastructure compliance",
        ],
      },

      {
        title: "Public Health & Environmental Protection",
        list: [
          "Air and water pollution litigation",
          "Noise pollution complaints and action",
          "Community environmental rights cases",
          "Legal action for ecological damage",
          "Protection of forests and biodiversity",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding environmental and regulatory issues",
          "Detailed legal and compliance assessment",
          "Strategic litigation and documentation",
          "Coordination with regulatory authorities",
          "Strong representation before tribunals",
          "Ensuring sustainable and lawful outcomes",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with environmental awareness to provide practical and effective solutions. Our team ensures compliance, reduces legal risks, and supports sustainable practices while delivering strong legal representation.",
      },

      {
        title: "Who We Help",
        list: [
          "Industries and manufacturing units",
          "Real estate and infrastructure companies",
          "Environmental organizations and NGOs",
          "Individuals facing environmental issues",
          "Businesses requiring compliance support",
        ],
      },
    ],
  },

  icon: "🌿",

  featureDetails: [
    {
      name: "NGT Appeals",
      img: envimg1,
      desc: "Challenging orders passed by environmental authorities. We provide strong representation before tribunals.",
    },
    {
      name: "Pollution Control",
      img: envimg2,
      desc: "Legal help regarding Pollution Control Board notices. We ensure compliance and proper legal response.",
    },
    {
      name: "Forest Clearances",
      img: envimg3,
      desc: "Guidance on ecological and forest permits. We assist in obtaining necessary approvals legally.",
    },
    {
      name: "Waste Management",
      img: envimg4,
      desc: "Compliance with waste management laws. We help industries meet environmental standards.",
    },
    {
      name: "Coastal Regulation",
      img: envimg5,
      desc: "Legal matters in CRZ zones. We ensure lawful construction and activity compliance.",
    },
    {
      name: "Noise Pollution",
      img: envimg6,
      desc: "Legal action against noise violations. We protect public and community rights.",
    },
    {
      name: "Mining Laws",
      img: envimg7,
      desc: "Handling disputes related to mining activities. We ensure environmental compliance in operations.",
    },
    {
      name: "Public Health PILs",
      img: envimg8,
      desc: "Litigation for clean air and water. We support community and environmental protection.",
    },
  ],

  helmetTitle: "Environmental Law Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Environmental Law services at Advocate Saurav Dagar Chambers. Expert legal support for NGT cases, pollution control, compliance, and environmental protection.",

  helmetKeywords:
    "Environmental Law, NGT Lawyer, Pollution Control, Compliance, Environmental Litigation India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Environmental Matters service page properly.",
},

  {
  id: "divorce-cases",

  title: "Divorce Cases",

  bannerImage: arbimg2,

  shortDesc:
    "Expert legal support in divorce, separation, and matrimonial disputes with a sensitive and strategic approach.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services for divorce and matrimonial disputes, ensuring a balance between legal protection and emotional sensitivity. Our team focuses on achieving fair outcomes while minimizing stress through strategic litigation and settlement options.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers all aspects of divorce law including mutual consent divorce, contested divorce, maintenance, and custody matters. We ensure that every case is handled with confidentiality, professionalism, and a strong legal strategy tailored to client needs.",
      },

      {
        title: "Divorce & Separation",
        list: [
          "Mutual consent divorce with faster resolution",
          "Contested divorce with strong legal representation",
          "Judicial separation cases",
          "Drafting and filing of divorce petitions",
          "Handling complex matrimonial disputes",
        ],
      },

      {
        title: "Child Custody & Rights",
        list: [
          "Child custody and visitation rights",
          "Ensuring welfare of the child",
          "Guardianship and parental rights cases",
          "Modification of custody orders",
          "Negotiation and mediation for family disputes",
        ],
      },

      {
        title: "Alimony & Financial Matters",
        list: [
          "Permanent and interim alimony cases",
          "Maintenance under Section 125 CrPC",
          "Financial settlements between spouses",
          "Enforcement of maintenance orders",
          "Protection of financial rights",
        ],
      },

      {
        title: "Legal Protection & Remedies",
        list: [
          "Domestic violence related legal support",
          "Dowry harassment and cruelty cases",
          "Protection orders and legal relief",
          "Filing complaints and legal notices",
          "Urgent legal intervention when required",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Confidential consultation and case evaluation",
          "Understanding emotional and legal concerns",
          "Strategic legal planning and documentation",
          "Encouraging amicable settlement when possible",
          "Strong courtroom representation if required",
          "Transparent communication and case updates",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We understand that divorce cases are emotionally challenging. Our team ensures a compassionate approach combined with strong legal expertise to protect your rights, maintain dignity, and achieve fair outcomes efficiently.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals seeking divorce or separation",
          "Spouses facing contested disputes",
          "Parents involved in custody matters",
          "Clients seeking alimony or maintenance",
          "Families needing legal resolution",
        ],
      },
    ],
  },

  icon: "💔",

  featureDetails: [
    {
      name: "Mutual Divorce",
      img: arbimg1,
      desc: "Fast-track divorce through mutual agreement. We ensure smooth and hassle-free legal processing.",
    },
    {
      name: "Contested Divorce",
      img: arbimg2,
      desc: "Strong representation in disputed divorce cases. We build effective strategies to protect your rights.",
    },
    {
      name: "Child Custody",
      img: arbimg3,
      desc: "Legal support for custody and visitation rights. We prioritize the child’s best interests.",
    },
    {
      name: "Alimony Matters",
      img: arbimg4,
      desc: "Handling financial settlements and maintenance claims. We ensure fair and lawful outcomes.",
    },
    {
      name: "Domestic Violence",
      img: arbimg5,
      desc: "Legal protection and support in abuse-related cases. We act quickly to secure safety and relief.",
    },
    {
      name: "Judicial Separation",
      img: arbimg6,
      desc: "Legal separation without divorce. We guide clients through structured legal processes.",
    },
    {
      name: "Family Mediation",
      img: arbimg7,
      desc: "Resolving disputes through mediation. We aim to reduce conflict and reach amicable solutions.",
    },
    {
      name: "Legal Documentation",
      img: arbimg8,
      desc: "Drafting petitions, agreements, and legal notices. We ensure accuracy and strong legal positioning.",
    },
  ],

  helmetTitle: "Divorce & Matrimonial Legal Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Divorce and Matrimonial services at Advocate Saurav Dagar Chambers. Expert lawyers providing trusted legal support in divorce, custody, and alimony matters.",

  helmetKeywords:
    "Divorce Lawyer, Matrimonial Cases, Child Custody, Alimony, Family Law India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Divorce Cases service page properly.",
},


{
  id: "property-disputes",

  title: "Property Disputes",

  bannerImage: cpimg3,

  shortDesc:
    "Expert legal solutions for property disputes, ownership conflicts, and real estate litigation.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services in property disputes, ensuring protection of ownership rights and smooth resolution of conflicts. Our team handles complex real estate matters with strategic planning, strong documentation, and effective court representation.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers a wide range of property disputes including title conflicts, illegal possession, boundary issues, and ownership claims. We ensure proper legal due diligence and representation to safeguard your property rights and investments.",
      },

      {
        title: "Ownership & Title Disputes",
        list: [
          "Resolving ownership conflicts and title issues",
          "Handling forged or disputed property documents",
          "Title verification and legal due diligence",
          "Partition and inheritance property disputes",
          "Legal notices for property claims",
        ],
      },

      {
        title: "Land & Possession Matters",
        list: [
          "Illegal possession and encroachment cases",
          "Recovery of possession through legal action",
          "Boundary and land demarcation disputes",
          "Agricultural and non-agricultural land issues",
          "Government land and acquisition disputes",
        ],
      },

      {
        title: "Real Estate & Builder Disputes",
        list: [
          "Builder-buyer disputes and delays",
          "Non-delivery of possession cases",
          "Agreement and documentation review",
          "Compensation claims against builders",
          "Legal action for project delays",
        ],
      },

      {
        title: "Court Representation",
        list: [
          "Civil suits for property disputes",
          "Injunctions to protect property rights",
          "Execution of property-related decrees",
          "Representation before courts and tribunals",
          "Handling appeals in higher courts",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Case evaluation and property document review",
          "Legal notice and pre-litigation strategy",
          "Strong documentation and evidence building",
          "Negotiation and settlement when possible",
          "Aggressive courtroom representation",
          "Ensuring final resolution and enforcement",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with practical knowledge of property laws to deliver effective solutions. Our focus is on protecting your assets, minimizing legal risks, and ensuring timely resolution of disputes.",
      },

      {
        title: "Who We Help",
        list: [
          "Property owners and buyers",
          "Real estate investors",
          "Families in inheritance disputes",
          "Landowners facing encroachment issues",
          "Clients involved in builder disputes",
        ],
      },
    ],
  },

  icon: "🏢",

  featureDetails: [
    {
      name: "Title Disputes",
      img: cpimg1,
      desc: "Resolving ownership and title conflicts. We ensure proper legal verification and protection of rights.",
    },
    {
      name: "Illegal Possession",
      img: cpimg2,
      desc: "Legal action against unauthorized occupation. We help recover possession through lawful means.",
    },
    {
      name: "Partition Cases",
      img: cpimg3,
      desc: "Division of ancestral and joint properties. We ensure fair and legal distribution among stakeholders.",
    },
    {
      name: "Builder Disputes",
      img: cpimg4,
      desc: "Handling delays and non-delivery issues. We secure compensation and legal remedies for buyers.",
    },
    {
      name: "Property Documentation",
      img: cpimg5,
      desc: "Verification and drafting of legal property documents. We prevent future disputes through accuracy.",
    },
    {
      name: "Encroachment Issues",
      img: cpimg6,
      desc: "Resolving land encroachment conflicts. We take swift legal action to protect your property.",
    },
    {
      name: "Injunction Orders",
      img: cpimg7,
      desc: "Securing court orders to prevent illegal actions. We protect your property rights proactively.",
    },
    {
      name: "Execution of Decrees",
      img: cpimg8,
      desc: "Enforcing court judgments effectively. We ensure final legal outcomes are implemented.",
    },
  ],

  helmetTitle: "Property Dispute Legal Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Property Dispute services at Advocate Saurav Dagar Chambers. Expert legal support for ownership disputes, land issues, builder conflicts, and real estate litigation.",

  helmetKeywords:
    "Property Disputes, Real Estate Lawyer, Land Disputes, Builder Issues, Property Law India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Property Disputes service page properly.",
},


 {
  id: "human-rights-pils",

  title: "Human Rights / PILs",

  bannerImage: humanimg2,

  shortDesc:
    "Strong legal advocacy for human rights protection, public interest litigation, and social justice.",

  fullDesc: {
    intro:
      "We are committed to protecting fundamental rights and promoting social justice through effective Public Interest Litigation (PIL) and human rights advocacy. Our work focuses on addressing systemic issues, government accountability, and safeguarding civil liberties.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice includes filing and handling PILs, protecting civil liberties, and addressing human rights violations. We work on matters that impact society at large and strive to bring meaningful legal reforms.",
      },

      {
        title: "Public Interest Litigation (PIL)",
        list: [
          "Drafting and filing PIL petitions",
          "Addressing social and environmental issues",
          "Challenging government inaction",
          "Ensuring accountability of public authorities",
          "Legal representation in higher courts",
        ],
      },

      {
        title: "Civil Liberties Protection",
        list: [
          "Protection against unlawful detention",
          "Safeguarding freedom of speech and expression",
          "Action against police misconduct",
          "Legal remedies for rights violations",
          "Ensuring constitutional protections",
        ],
      },

      {
        title: "Social Justice & Advocacy",
        list: [
          "Promoting equality and non-discrimination",
          "Legal action for marginalized communities",
          "Women and child rights advocacy",
          "Access to education and basic rights",
          "Challenging unjust laws and practices",
        ],
      },

      {
        title: "Environmental & Community Rights",
        list: [
          "PILs for clean air and water",
          "Protection of public health and environment",
          "Action against illegal constructions",
          "Safeguarding community resources",
          "Legal remedies for environmental damage",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Identifying key public issues",
          "Detailed legal research and case preparation",
          "Strategic filing of PILs",
          "Strong courtroom advocacy",
          "Collaboration with stakeholders and activists",
          "Focused on long-term societal impact",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We are dedicated to creating meaningful change through law. Our team combines legal expertise with a strong commitment to justice, ensuring every case contributes to a fair and equitable society.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals facing rights violations",
          "Social activists and NGOs",
          "Communities affected by injustice",
          "Victims of discrimination or abuse",
          "Citizens seeking government accountability",
        ],
      },
    ],
  },

  icon: "📢",

  featureDetails: [
    {
      name: "Civil Liberty Protection",
      img: humanimg1,
      desc: "Safeguarding individuals against unlawful actions by authorities and ensuring constitutional rights.",
    },
    {
      name: "Environmental PILs",
      img: humanimg2,
      desc: "Legal action for protecting environment and ensuring clean and safe surroundings.",
    },
    {
      name: "Prisoner Rights",
      img: humanimg3,
      desc: "Advocating humane treatment and legal aid for prisoners and detainees.",
    },
    {
      name: "Women Empowerment",
      img: humanimg4,
      desc: "Promoting gender equality and providing legal support against discrimination.",
    },
    {
      name: "Social Reform",
      img: humanimg5,
      desc: "Challenging outdated laws and practices for progressive social change.",
    },
    {
      name: "Child Advocacy",
      img: humanimg6,
      desc: "Protecting children from exploitation and ensuring their right to education and safety.",
    },
    {
      name: "RTI Petitions",
      img: humanimg7,
      desc: "Using RTI laws to promote transparency and accountability in governance.",
    },
    {
      name: "Equality Suits",
      img: humanimg8,
      desc: "Fighting discrimination in workplaces, institutions, and society.",
    },
  ],

  helmetTitle: "Human Rights & PIL Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Expert legal services for Human Rights and Public Interest Litigation at Advocate Saurav Dagar Chambers. We protect fundamental rights and promote justice through PILs.",

  helmetKeywords:
    "Human Rights Law, PIL India, Public Interest Litigation, Civil Rights, Legal Services, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Human Rights / PILs service page properly.",
},


 {
  id: "commercial-disputes",

  title: "Commercial Disputes",

  bannerImage: commercialimg3,

  shortDesc:
    "Expert legal solutions for business disputes, contract breaches, and commercial litigation.",

  fullDesc: {
    intro:
      "We provide comprehensive legal services for resolving commercial disputes, ensuring protection of business interests and smooth conflict resolution. Our team handles complex matters involving contracts, partnerships, and corporate issues through litigation, arbitration, and mediation.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers a wide range of commercial disputes including contract enforcement, recovery of money, partnership conflicts, and corporate litigation. We aim to resolve disputes efficiently while safeguarding business interests.",
      },

      {
        title: "Contract & Business Disputes",
        list: [
          "Breach of contract cases",
          "Drafting and enforcement of agreements",
          "Business transaction disputes",
          "Vendor and supplier conflicts",
          "Negotiation and settlement support",
        ],
      },

      {
        title: "Recovery of Money",
        list: [
          "Legal action for outstanding dues",
          "Commercial recovery suits",
          "Execution of decrees",
          "Debt recovery strategies",
          "Negotiation and settlement of claims",
        ],
      },

      {
        title: "Partnership & Corporate Issues",
        list: [
          "Disputes among business partners",
          "Company internal conflicts",
          "Shareholder disputes",
          "Business restructuring matters",
          "Legal advisory for corporate governance",
        ],
      },

      {
        title: "NCLT & Corporate Litigation",
        list: [
          "Representation before NCLT",
          "Insolvency and bankruptcy matters",
          "Company law disputes",
          "Mergers and restructuring cases",
          "Corporate compliance issues",
        ],
      },

      {
        title: "Intellectual Property & Compliance",
        list: [
          "Trademark and copyright disputes",
          "Protection of intellectual assets",
          "Compliance audits and legal checks",
          "Trade secret protection",
          "Regulatory compliance advisory",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding business objectives",
          "Detailed legal and financial analysis",
          "Strategic dispute resolution planning",
          "Preference for negotiation and mediation",
          "Strong litigation when required",
          "Ensuring minimal business disruption",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with a strong understanding of business dynamics. Our focus is on delivering practical and result-oriented solutions that protect commercial interests and ensure long-term stability.",
      },

      {
        title: "Who We Help",
        list: [
          "Business owners and companies",
          "Partnership firms",
          "Startups and entrepreneurs",
          "Corporate stakeholders",
          "Clients involved in commercial disputes",
        ],
      },
    ],
  },

  icon: "💼",

  featureDetails: [
    {
      name: "Contract Disputes",
      img: commercialimg1,
      desc: "Resolving breaches and conflicts in business contracts effectively.",
    },
    {
      name: "Recovery of Money",
      img: commercialimg2,
      desc: "Legal assistance in recovering outstanding business dues.",
    },
    {
      name: "Partnership Matters",
      img: commercialimg3,
      desc: "Handling disputes among partners with strategic legal solutions.",
    },
    {
      name: "Company Issues",
      img: commercialimg4,
      desc: "Resolving corporate conflicts and compliance matters.",
    },
    {
      name: "NCLT Representation",
      img: commercialimg5,
      desc: "Expert representation before the National Company Law Tribunal.",
    },
    {
      name: "Intellectual Property",
      img: commercialimg6,
      desc: "Protecting trademarks, copyrights, and business innovations.",
    },
    {
      name: "Compliance Audit",
      img: commercialimg7,
      desc: "Ensuring all business operations meet legal standards.",
    },
    {
      name: "Trade Secrets",
      img: commercialimg8,
      desc: "Safeguarding confidential business information legally.",
    },
  ],

  helmetTitle: "Commercial Disputes Legal Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Expert Commercial Disputes services at Advocate Saurav Dagar Chambers. We handle contract disputes, business conflicts, recovery cases, and corporate litigation.",

  helmetKeywords:
    "Commercial Disputes India, Business Law, Contract Disputes, NCLT, Corporate Litigation, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Commercial Disputes service page properly.",
},

{
  id: "company-related-issue",

  title: "Company Related Issue",

  bannerImage: cpimg3,

  shortDesc:
    "Comprehensive legal services for corporate compliance, governance, disputes, and business structuring.",

  fullDesc: {
    intro:
      "We provide end-to-end legal solutions for company-related matters, helping businesses operate smoothly while ensuring full legal compliance. Our team offers strategic advice and strong representation in corporate governance, disputes, and regulatory issues.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice covers all aspects of company law, including incorporation, compliance, shareholder disputes, and corporate restructuring. We assist businesses at every stage, from formation to expansion and dispute resolution, ensuring legal stability and growth.",
      },

      {
        title: "Company Formation & Structuring",
        list: [
          "Incorporation of Private Limited, LLP, and OPC companies",
          "Drafting MoA, AoA, and partnership agreements",
          "Business structure advisory and legal setup",
          "Registration and licensing procedures",
          "Startup legal support and compliance",
        ],
      },

      {
        title: "Corporate Compliance & Governance",
        list: [
          "ROC filings and annual compliance management",
          "Maintaining statutory registers and records",
          "Secretarial audits and compliance checks",
          "Advisory on Companies Act provisions",
          "Corporate governance and policy drafting",
        ],
      },

      {
        title: "Disputes & Litigation",
        list: [
          "Shareholder and partnership disputes",
          "Mismanagement and oppression cases",
          "Director liability and fiduciary duties",
          "Representation before NCLT and courts",
          "Legal notices and dispute resolution strategies",
        ],
      },

      {
        title: "Mergers, Acquisitions & Restructuring",
        list: [
          "M&A due diligence and legal risk assessment",
          "Drafting and reviewing transaction documents",
          "Business restructuring and joint ventures",
          "Compliance in mergers and acquisitions",
          "Advisory on corporate expansion strategies",
        ],
      },

      {
        title: "Closure & Exit Management",
        list: [
          "Company winding up and dissolution",
          "Strike-off procedures and compliance",
          "Exit strategies for directors and shareholders",
          "Settlement of liabilities and assets",
          "Legal documentation for closure",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Understanding business requirements and risks",
          "Detailed legal and compliance assessment",
          "Strategic planning and documentation",
          "Proactive compliance management",
          "Strong representation in disputes",
          "Ensuring smooth business operations",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We combine legal expertise with business understanding to provide practical and effective solutions. Our focus is on minimizing legal risks, ensuring compliance, and supporting business growth through reliable legal strategies.",
      },

      {
        title: "Who We Help",
        list: [
          "Startups and entrepreneurs",
          "Small and medium enterprises (SMEs)",
          "Corporate entities and companies",
          "Directors and shareholders",
          "Investors and business partners",
        ],
      },
    ],
  },

  icon: "🏢",

  featureDetails: [
    {
      name: "Incorporation",
      img: cpimg1,
      desc: "Formation of Private Limited, LLP, and OPC companies. We ensure smooth and compliant business setup.",
    },
    {
      name: "ROC Compliance",
      img: cpimg2,
      desc: "Managing annual filings and statutory records. We keep your company fully compliant.",
    },
    {
      name: "Shareholder Rights",
      img: cpimg3,
      desc: "Legal representation in internal company conflicts. We protect stakeholder interests effectively.",
    },
    {
      name: "M&A Due Diligence",
      img: cpimg4,
      desc: "Evaluating legal risks in mergers and acquisitions. We ensure safe and informed business decisions.",
    },
    {
      name: "Company Winding Up",
      img: cpimg5,
      desc: "Assisting in legal closure and dissolution. We handle compliance and documentation smoothly.",
    },
    {
      name: "Director Liability",
      img: cpimg6,
      desc: "Advisory on directors' duties and liabilities. We ensure legal protection and compliance.",
    },
    {
      name: "Secretarial Audit",
      img: cpimg7,
      desc: "Ensuring company records meet statutory requirements. We identify and fix compliance gaps.",
    },
    {
      name: "MoA & AoA Drafting",
      img: cpimg8,
      desc: "Drafting charter documents for companies. We ensure strong legal foundations for your business.",
    },
  ],

  helmetTitle: "Company Law & Corporate Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Company Law services at Advocate Saurav Dagar Chambers. Expert legal support for incorporation, compliance, corporate disputes, and business structuring.",

  helmetKeywords:
    "Company Law, Corporate Lawyer, ROC Compliance, Incorporation, Business Law India, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Company Related Issue service page properly.",
},

{
  id: "bail-trial",

  title: "Bail Trial",

  bannerImage: criminalimg4,

  shortDesc:
    "Expert legal representation in bail matters including anticipatory, regular bail, and trial-stage advocacy.",

  fullDesc: {
    intro:
      "We provide specialized legal services in bail matters, ensuring swift action and strong representation to protect your liberty. From anticipatory bail to regular bail during trial, our team focuses on strategic legal planning and effective courtroom advocacy.",

    sections: [
      {
        title: "Our Legal Expertise",
        content:
          "Our practice focuses on handling all types of bail matters under criminal law. We assist clients in securing bail at various stages, ensuring compliance with legal procedures while protecting their fundamental rights and freedom.",
      },

      {
        title: "Bail & Pre-Arrest Protection",
        list: [
          "Anticipatory bail applications for pre-arrest protection",
          "Regular bail during investigation and trial",
          "Urgent bail filings in sensitive cases",
          "Handling non-bailable offences",
          "Interim bail applications",
        ],
      },

      {
        title: "Court Representation",
        list: [
          "Representation during bail hearings",
          "Drafting bail applications and arguments",
          "Presenting evidence and legal grounds",
          "Handling objections from prosecution",
          "Strong advocacy before courts",
        ],
      },

      {
        title: "Legal Strategy & Case Support",
        list: [
          "FIR analysis and legal advice",
          "Case evaluation and documentation",
          "Strategic planning for bail approval",
          "Coordination with police and courts",
          "Ensuring procedural compliance",
        ],
      },

      {
        title: "Post-Bail & Trial Support",
        list: [
          "Guidance on bail conditions compliance",
          "Representation during trial proceedings",
          "Modification of bail conditions",
          "Handling bail cancellation matters",
          "Appeals against bail rejection",
        ],
      },

      {
        title: "Our Approach",
        list: [
          "Immediate consultation and case assessment",
          "Urgent filing of bail applications",
          "Strong legal research and preparation",
          "Effective courtroom representation",
          "Continuous updates and client support",
          "Ensuring timely relief and protection",
        ],
      },

      {
        title: "Why Choose Us",
        content:
          "We understand the urgency and sensitivity of bail matters. Our team ensures quick action, strategic legal planning, and strong courtroom advocacy to secure bail efficiently while protecting your rights.",
      },

      {
        title: "Who We Help",
        list: [
          "Individuals facing criminal charges",
          "Clients seeking anticipatory bail",
          "Accused persons in ongoing trials",
          "Families seeking urgent legal help",
          "Clients in high-risk legal situations",
        ],
      },
    ],
  },

  icon: "⚖️",

  featureDetails: [
    {
      name: "Regular Bail",
      img: criminalimg1,
      desc: "Representation for securing release during investigation or trial. We ensure timely filing and strong legal arguments.",
    },
    {
      name: "Anticipatory Bail",
      img: criminalimg2,
      desc: "Legal protection against potential arrest. We prepare proactive strategies to safeguard your liberty.",
    },
    {
      name: "Bail Hearing Representation",
      img: criminalimg3,
      desc: "Expert advocacy during bail hearings. We present strong arguments for favorable outcomes.",
    },
    {
      name: "FIR Review & Advice",
      img: criminalimg4,
      desc: "Legal guidance before or after FIR registration. We help you take the right legal steps early.",
    },
    {
      name: "Legal Strategy",
      img: criminalimg5,
      desc: "Comprehensive planning to maximize bail approval chances. We build a strong legal foundation.",
    },
    {
      name: "Court Liaison",
      img: criminalimg6,
      desc: "Coordination with courts and authorities. We ensure smooth and timely processing of bail applications.",
    },
  ],

  helmetTitle: "Bail & Criminal Defense Services - Advocate Saurav Dagar Chambers",

  helmetDescription:
    "Explore Bail and Criminal Defense services at Advocate Saurav Dagar Chambers. Expert lawyers providing strong representation in anticipatory bail, regular bail, and hearings.",

  helmetKeywords:
    "Bail Lawyer, Anticipatory Bail, Regular Bail, Criminal Defense, Bail Hearing, Advocate Saurav Dagar Chambers",

  helmetnoscript:
    "Please enable JavaScript to view this Bail Trial service page properly.",
}

];
